import { Modal } from 'antd';
import { useSectionScrollSync } from '../hooks/useSectionScrollSync';
import styles from '../Style/FeaturesModal.module.scss';
import { featuresLinks } from './featuresLinks';
import { FeaturesNavigation } from './FeaturesNavigation';
import { AnalyticsSection } from './sections/AnalyticsSection';
import { ApiAccessSection } from './sections/ApiAccessSection';
import { DataReportSection } from './sections/DataReportSection';
import { FeatureSection } from './sections/FeatureSection';
import { IntroductionSection } from './sections/IntroductionSection';
import { MapLayersSection } from './sections/MapLayersSection';
import { MikeMetoceanSimulatorSection } from './sections/MikeMetoceanSimulatorSection';
import { RecordingsSection } from './sections/RecordingsSection';
import { ValidationSection } from './sections/ValidationSection';

type PrivateProps = {
  visible: boolean;
  onHandleFeaturesModalCancel: () => void;
  handleCloseAllModals: () => void;
};

const sectionSlugs = featuresLinks.map((link) => link.slug);

export default function FeaturesModal({
  visible,
  onHandleFeaturesModalCancel,
  handleCloseAllModals,
}: PrivateProps) {
  const { activeLink, contentRef, registerSection, goToSection } = useSectionScrollSync(
    visible,
    sectionSlugs
  );

  return (
    <Modal
      centered
      footer={null}
      className={`featuresModal ${styles.featuresModal}`}
      title={[
        <div className={styles.modalTitle} key={'featuresModal-title-container'}>
          <h1>Get started</h1>
          <div>
            The portal offers a suit of features to access, visualize and process metocean data. The
            key features comprise
            <a href="#validation"> Validation</a>,<a href="#analytics"> Analytics</a>,
            <a href="#mike-metocean-simulator"> MIKE Metocean Simulator</a>,
            <a href="#map-layers"> Map Layers</a>,<a href="#api"> API Access</a>, and
            <a href="#data-report"> Data Report</a>.
          </div>
        </div>,
      ]}
      open={visible}
      onCancel={onHandleFeaturesModalCancel}
      width={'65vw'}
    >
      <div className={styles.featuresModalContent}>
        <FeaturesNavigation activeLink={activeLink} onLinkClick={goToSection} />
        <div className={styles.content} ref={contentRef}>
          <FeatureSection id="introduction" sectionRef={registerSection('introduction')}>
            <IntroductionSection />
          </FeatureSection>
          <FeatureSection id="recordings" sectionRef={registerSection('recordings')}>
            <RecordingsSection />
          </FeatureSection>
          <FeatureSection id="validation" sectionRef={registerSection('validation')}>
            <ValidationSection />
          </FeatureSection>
          <FeatureSection id="analytics" sectionRef={registerSection('analytics')}>
            <AnalyticsSection handleCloseAllModals={handleCloseAllModals} />
          </FeatureSection>
          <FeatureSection
            id="mike-metocean-simulator"
            sectionRef={registerSection('mike-metocean-simulator')}
          >
            <MikeMetoceanSimulatorSection />
          </FeatureSection>
          <FeatureSection id="map-layers" sectionRef={registerSection('map-layers')}>
            <MapLayersSection />
          </FeatureSection>
          <FeatureSection id="api" sectionRef={registerSection('api')}>
            <ApiAccessSection />
          </FeatureSection>
          <FeatureSection id="data-report" sectionRef={registerSection('data-report')}>
            <DataReportSection />
          </FeatureSection>
        </div>
      </div>
    </Modal>
  );
}
